import React from 'react';
import OeTip from './OeTip';

// Ampel je Verfügbarkeits-Kategorie (Original `availIcon`, Zeile 1381).
const ICONS = {
    3: {cls: 'av prod', text: '⚙', tip: 'verfügbar durch Produktion (Produktionsartikel)'},
    2: {cls: 'av ok', text: '✓', tip: 'verfügbar'},
    1: {cls: 'av low', text: '', tip: 'teilweise verfügbar'},
    0: {cls: 'av no', text: '✕', tip: 'nicht verfügbar'},
    '-1': {cls: 'av unk', text: '', tip: 'wird geladen'},
    none: {cls: 'av none', text: '–', tip: 'wird nicht geliefert (Lager „Keine")'},
};

/**
 * @param {number} cat
 * @param {string} [tip] - ersetzt den Standardtext, wenn der Grund für die
 *   graue Ampel ein anderer ist als „wird noch geladen" (z. B. eine Position,
 *   die gar nicht geliefert wird).
 */
export default function AvailIcon({cat, tip}) {
    const cfg = ICONS[String(cat)] || ICONS['-1'];

    return (
        <OeTip tip={tip || cfg.tip}>
            <span className={cfg.cls}>{cfg.text}</span>
        </OeTip>
    );
}

/** Nur das Symbol ohne Sprechblase — für die Filterknöpfe im Tabellenkopf. */
export function AvailGlyph({cat}) {
    const cfg = ICONS[String(cat)] || ICONS['-1'];

    return <span className={cfg.cls}>{cfg.text}</span>;
}

export {ICONS as AVAIL_ICONS};
